import { isProdEnv } from "../utils"

let BASE_URL

if (isProdEnv()) {
  BASE_URL = "https://k-api-3h7d387yt3h89d.cleanbox.co.il"
} else {
  BASE_URL = "https://k-api-test.cleanbox.co.il"
  //BASE_URL = "https://localhost:5002" //Please, leave for developer
}

export default BASE_URL
